import loadingWheel from '../../assets/loading.svg';

const LoadingSpinner = () => {
    return (
        <div className="flex fixed z-[10000] backdrop-blur-md h-full w-full items-center justify-center">
          <img src={loadingWheel} alt="" className="w-20 h-20" />
        </div>
    )
}

export default LoadingSpinner;